import { render, staticRenderFns } from "./BrandPartner.vue?vue&type=template&id=2fe9ae61&scoped=true&"
import script from "./BrandPartner.vue?vue&type=script&lang=js&"
export * from "./BrandPartner.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartner.vue?vue&type=style&index=0&id=2fe9ae61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9ae61",
  null
  
)

export default component.exports